















import { Component, Prop, PropSync, Vue, Watch } from "vue-property-decorator";

@Component
export default class RevertableInput extends Vue {
  @Prop({ default: "" }) label!: string;
  @Prop({ default: "" }) originalValue!: string;
  @Prop({ default: "is-info" }) type!: string;
  @Prop({ default: false }) required!: boolean;
  @Prop({ default: "text" }) inputType!: string;
  @PropSync("value") syncedValue!: string | number;

  @Watch("syncedValue")
  onValueChange(newValue: string | number) {
    if (this.inputType === "number" && typeof newValue === "string") {
      this.syncedValue = Number(newValue);
    }
  }
}
